import React from 'react';
import formStyles from '../../../form/Form.module.css';

/* Componentes padrão */
import Input from '../../../form/Input';
import Select from '../../../form/Select';
import DataList from '../../../form/DataList';

const VtrSection = ({ bem, actions, state }) => {
    return (
        <div id="divMovel">
            <div className={formStyles.preview_bandeira}>
                <h4>Informações específicas do veículo (VTR)</h4>
            </div>

            {/* --- LINHA 1: MODELO, COR E ANOS --- */}
            <div className={formStyles.row}>
                <DataList
                    text="Modelo"
                    title="Vincula o modelo do BEM"
                    name="produtoModelo.descricao"
                    inputWidth="350px"
                    filteredOptions={state.OptionsModelo}
                    handleOnChange={actions.draft.change}
                    handleOnFocus={actions.draft.focus}
                    handleOnBlur={actions.draft.blur}
                    value={state.Modelo?.descricao || ''}
                />
                <Select
                    name="produtoBens.corId"
                    text="Cor"
                    options={state.OptionsCores}
                    handleOnChange={actions.draft.change}
                    value={bem.corId}
                    isEnum={false}
                    notOptNull={true}
                />
                <Input
                    text="Ano Fabricação"
                    type="number"
                    name="produtoBens.anoFabricacao"
                    inputWidth="110px"
                    handleOnChange={actions.draft.change}
                    value={bem.anoFabricacao || ''}
                />
                <Input
                    text="Ano Modelo"
                    type="number"
                    name="produtoBens.anoModelo"
                    inputWidth="110px"
                    handleOnChange={actions.draft.change}
                    value={bem.anoModelo || ''}
                />
                <Input
                    text="Km inicial"
                    type="number"
                    name="produtoBens.kmInicial"
                    inputWidth="100px"
                    handleOnChange={actions.draft.change}
                    value={bem.kmInicial || ''}
                />
            </div>

            {/* --- LINHA 2: DOCUMENTAÇÃO --- */}
            <div className={formStyles.row}>
                <Input
                    text="Placa"
                    name="produtoBens.placa"
                    inputWidth="150px"
                    handleOnChange={actions.draft.change}
                    value={bem.placa || ''}
                />
                <Input
                    text="Chassi"
                    name="produtoBens.chassi"
                    inputWidth="250px"
                    handleOnChange={actions.draft.change}
                    value={bem.chassi || ''}
                />
                <Input
                    text="Renavan"
                    type="number"
                    name="produtoBens.renavan"
                    inputWidth="180px"
                    handleOnChange={actions.draft.change}
                    value={bem.renavan || ''}
                />
                <Input
                    text="CRV"
                    type="number"
                    name="produtoBens.crv"
                    inputWidth="180px"
                    handleOnChange={actions.draft.change}
                    value={bem.crv || ''}
                />
            </div>
        </div>
    );
};

export default VtrSection;
